/**
 * Split `total` across `weights` proportionally, returning a same-length array
 * of 2-decimal allocations whose sum exactly equals `total`. The last entry
 * absorbs any rounding remainder.
 *
 * Mirrors `dent-cloud-service/src/utils/allocateProportionally.js` so the
 * receipt-level discount preview on the frontend matches the backend
 * distribution exactly.
 */
export default function allocateProportionally(weights, total) {
  const sumWeights = weights.reduce((s, w) => s + w, 0);
  if (sumWeights === 0 || total === 0) {
    return weights.map(() => 0);
  }

  const result = new Array(weights.length);
  let distributed = 0;
  for (let i = 0; i < weights.length - 1; i++) {
    const share = Math.round((weights[i] / sumWeights) * total * 100) / 100;
    result[i] = share;
    distributed += share;
  }
  result[weights.length - 1] = Math.round((total - distributed) * 100) / 100;
  return result;
}
